import React from "react"
import {
  HandleValidDate,
  FormatDate,
  FormatDateDDMMMYYYY,
} from "helpers/method_helper"

const HealthdayMonitoringColumns = [
  {
    Header: "Name",
    accessor: row => `${row.FirstName} ${row.LastName}`,
  },
  {
    Header: "Gender / Ethnicity",
    accessor: "Gender", // keep accessor for filtering/sorting
    Cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem", lineHeight: "1.2" }}>
        <div>{row.original.Gender || ""}</div>
        <small>{row.original.Ethnicity || ""}</small>
      </div>
    ),
  },
  {
    Header: "DOB",
    accessor: "DateOfBirth",
    Cell: ({ value }) => (
      <div style={{ fontSize: "0.85rem" }}>
        {value ? FormatDateDDMMMYYYY(value) : ""}
      </div>
    ),
  },
  {
    Header: "Contact",
    accessor: "Mobile",
    Cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem", lineHeight: "1.2" }}>
        <div>{row.original.ContactNumber || ""}</div>
        <small>{row.original.EmailAddress || ""}</small>
      </div>
    ),
  },
  {
    Header: "Mobile Network",
    accessor: "MobileNetwork",
    Cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem", lineHeight: "1.2" }}>
        <div>{row.original.MobileNetwork || ""}</div>
        <small>{row.original.PhoneContract || ""}</small>
      </div>
    ),
  },
  {
    Header: "NDB Status",
    accessor: "NDBAdded",
    Cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem", lineHeight: "1.2" }}>
        <div>Registered: {row.original.NDBRegistered ? "Yes" : "No"}</div>
        <small>Network: {row.original.NDBNetworkType || ""}</small>
      </div>
    ),
  },
  {
    Header: "MMP Group / Smoke Alarm",
    accessor: "MMPGroup",
    Cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem", lineHeight: "1.2" }}>
        <div>{row.original.MMPGroup || ""}</div>
        <small>Alarm: {row.original.SmokeAlarm ? "Yes" : "No"}</small>
      </div>
    ),
  },
  {
    Header: "Address",
    accessor: "Address",
    Cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem", lineHeight: "1.2" }}>
        <div>{row.original.Address || ""}</div>
        <small>
          {row.original.Area || ""} {row.original.Postcode || ""}
        </small>
      </div>
    ),
  },
  {
    Header: "Centre",
    accessor: "Centre",
    Cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem", lineHeight: "1.2" }}>
        <div>{row.original.Centre || ""}</div>
        <small>{row.original.Venue || ""}</small>
      </div>
    ),
  },
  {
    Header: "Created",
    accessor: "CreatedByName",
    Cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem", lineHeight: "1.2" }}>
        <div>{row.original.CreatedByName || ""}</div>
        <small>
          {row.original.CreatedDate
            ? FormatDateDDMMMYYYY(row.original.CreatedDate)
            : ""}
        </small>
      </div>
    ),
  },
]

export { HealthdayMonitoringColumns }
